  <div *ngFor="let item of items" class="menu-item" (click)="navigate(item)">
      <img [src]="item.icon" alt="{{item.label}}" class="menu-icon" />
      <span class="menu-label">{{ item.label }}</span>
    </div>
  

    